import { RefObject, useCallback } from 'react';
import {
  HashScroll as ReactHashScroll,
  HashScrollProps as ReactHashScrollProps,
} from 'react-hash-scroll';
import { useHistory } from 'react-router-dom';

export type HashScrollProps = Omit<ReactHashScrollProps, 'scrollFunc'>;

export const HashScroll = (props: HashScrollProps) => {
  const history = useHistory();

  const handleScrollFunc = useCallback(
    <T extends HTMLElement>(
      ref: RefObject<T>,
      behavior: ScrollBehavior,
      position: ScrollLogicalPosition
    ) => {
      ref.current?.scrollIntoView({ behavior, block: position });
      history.replace({ hash: undefined });
    },
    [history]
  );

  return <ReactHashScroll scrollFunc={handleScrollFunc} {...props} />;
};
